import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Spring/MultiplicationAndDivisionB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionB',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/1MultiplesOf10" */ './1MultiplesOf10'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/2RelatedCalculations" */ './2RelatedCalculations'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/3ReasoningAboutMultiplication" */ './3ReasoningAboutMultiplication'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/4MultiplyA2DigitNumberByA1DigitNumberNoExchange" */ './4MultiplyA2DigitNumberByA1DigitNumberNoExchange'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/5MultiplyA2DigitNumberByA1DigitNumberWithExchange" */ './5MultiplyA2DigitNumberByA1DigitNumberWithExchange'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/6LinkMultiplicationAndDivision" */ './6LinkMultiplicationAndDivision'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/7DivideA2DigitNumberByA1DigitNumberNoExchange" */ './7DivideA2DigitNumberByA1DigitNumberNoExchange'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/8DivideA2DigitNumberByA1DigitNumberFlexiblePartitioning" */ './8DivideA2DigitNumberByA1DigitNumberFlexiblePartitioning'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/9DivideA2DigitNumberByA1DigitNumberWithRemainders" */ './9DivideA2DigitNumberByA1DigitNumberWithRemainders'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/10Scaling" */ './10Scaling'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MultiplicationAndDivisionB/11HowManyWays" */ './11HowManyWays'
        )
    })
  ]
});
export default Block;
